<main>
  <div
    class="flex flex-column justify-content-center align-items-center px-2 py-5"
  >
    <div class="w-6">
      <h1 class="text-center mb-4">Password reset</h1>

      <p-panel>
        <form
          [formGroup]="resetPasswordForm"
          (ngSubmit)="onSubmit()"
          class="p-fluid flex flex-column gap-5"
        >
          <p class="mt-4 text-center">
            Forgotten your password? Enter your email address below, and we'll
            email instructions for setting a new one.
          </p>

          <!-- Error message -->
          @if (errorMessage) {
            <div class="mt-1">
              <p-message severity="error" [text]="errorMessage"></p-message>
            </div>
          }

          <!-- Email -->
          <p-floatLabel>
            <input
              pInputText
              id="emailInput"
              formControlName="email"
              class="w-full"
              type="email"
              pTooltip="The email address you registered your account with."
            />
            <label for="emailInput">Email</label>
          </p-floatLabel>

          <!-- Submit -->
          <div class="flex justify-content-center">
            <button
              pButton
              type="submit"
              label="Reset my password"
              class="w-6"
              [disabled]="resetPasswordForm.invalid"
            ></button>
          </div>
        </form>
      </p-panel>
    </div>
  </div>
</main>
